import confluence from './confluence.png';
import github from './github.png';
import google from './google.png';
import googleDocs from './google-docs.png';

export { confluence, github, google, googleDocs };
